import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from './PageHero';
import BlogsGrid from './BlogsGrid';
import Pagination from './Pagination';
import ContactCTAStrip from './ContactCTAStrip';
import { getBlogsData } from '../data/blogsData';

const Blogs = () => {
  const { t } = useTranslation();
  const allPosts = useMemo(() => getBlogsData(t), [t]);


  const ITEMS_PER_PAGE = 6;

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const totalPages = Math.ceil(allPosts.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentPosts = allPosts.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="blogs-page">
      <PageHero title="Blogs" />
      <section className="blogs-section section-padding">
        <div className="container">
          <BlogsGrid posts={currentPosts} />
          <Pagination 
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={handlePageChange} 
          />
        </div>
      </section>
      <ContactCTAStrip />
    </div>
  );
};

export default Blogs;
